import styles from './Termsofuse.module.css';
const Termsofuse = () => {
  return (
    <div className={styles.container}>
        <h3 className={styles.mainheader}>iCredentialing Website Terms of Use</h3>
        <p className={styles.content}><em>Last updated: May 30, 2025</em></p>
        <p className={styles.content}>
            Innovative Health Systems, Inc., doing business as <strong>iCredentialing</strong> (“iCredentialing,” “we,” “us,”
        or “our”), provides and maintains this website, <strong>icredentialing.com</strong> (including all subpages, the
        “Site”), strictly for general informational purposes. These Website Terms of Use (the “Terms”)
        govern your access to and use of the Site. By accessing or using the Site, you agree to be bound
        by these Terms in their entirety. If you do not agree to these Terms, do not access or use the Site.</p>

        <h1 className={styles.subheader}>1. Acceptance of These Terms</h1>
        <p className={styles.content}>
            1.1. By visiting or using the Site, you confirm that you have read, understand, and agree to these
        Terms. </p>
        <p className={styles.content}>
            1.2. <strong>The Site is for informational purposes only.</strong> It is not intended to collect or transmit
        Protected Health Information (“PHI”) or any sensitive personal data. You must not upload, post,
        or transmit any information containing personal identifiers, medical histories, professional
        credentials, or any other PHI through the public Site.</p>
        <p className={styles.content}>
            1.3. Once you have formally engaged iCredentialing’s services (e.g., by executing a Master
        Services Agreement or other service contract), we will provide you with secure, HIPAA-
        compliant login credentials to a separate portal where you may enter personal and credentialing
        information or upload documents containing personal data.</p>

        <h1 className={styles.subheader}>2. Changes to the Site or Terms</h1>
        <p className={styles.content}>
            2.1. We may modify the Site or update these Terms at any time, at our sole discretion. Any
        changes are effective upon posting. Your continued use of the Site after the effective date of any
        change constitutes acceptance of the revised Terms.
        </p>
        <p className={styles.content}>
        2.2. <strong>Any change to how personal or professional data is managed or secured</strong> will be
        communicated in accordance with applicable HIPAA, HITECH, NCQA, URAC, TJC, and CMS
        requirements. We recommend reviewing these Terms periodically.
        </p>
        <h1 className={styles.subheader}>
        3. Informational Nature of the Site
        </h1>
        <p className={styles.content}>
             3.1. The Site contains general information about iCredentialing and its credentialing, payer-
        enrollment, monitoring, and compliance services (collectively, the “Services”). The content on
        the Site is provided <strong>“as is”</strong> and for informational purposes only.
        </p>
        <p className={styles.content}>
            3.2. <strong>No credentialing or payer-enrollment activities occur on the public Site.</strong> All
        credentialing, payer-enrollment, or other regulated healthcare workflows take place within a
        secure, HIPAA-compliant portal under a separate Master Services Agreement (or applicable
        service contract) that adheres to NCQA, URAC, TJC, and CMS requirements.
        </p>
        <p className={styles.content}>
             3.3. The Site does not constitute a binding offer, nor does it amend or replace any contract for
        Services. Any obligations, rights, or remedies relating to iCredentialing’s Services are governed
        solely by your executed service agreement with iCredentialing.
        </p>
       <h1 className={styles.subheader}>4. Permitted and Prohibited Uses</h1>
        <p>
        4.1. You may view, download (temporarily), and print materials from the Site only for your own
        internal, non-commercial reference, provided that you:
        </p>
        <ul className={styles.listelements}>
            <li key='1'> Retain any copyright, trademark, or other proprietary notices.</li>
            <li key='2'> Do not alter, modify, or create derivative works from the content.</li>
        </ul>
       
        <p className={styles.content}>
            4.2. You must <strong>not</strong>:
        </p>
        <p className={styles.content}>
             a. Transmit, post, or store any Protected Health Information (PHI) or other sensitive personal
        data via the public Site. All credentialing documents containing personal or PHI data must be
        submitted exclusively through our secure, HIPAA-compliant portal after you obtain approved
        credentials.
        </p>
        <p className={styles.content}>
             b. Copy, reproduce, republish, upload, post, transmit, distribute, or create derivative works from
        any portion of the Site, in whole or in part, except as expressly permitted in these Terms.
        </p>
        <p className={styles.content}>
             c. Reverse-engineer, decompile, or attempt to extract source code from any software available on
        the Site.
        </p>
        <p className={styles.content}>
            d. Interfere with or disrupt the Site, iCredentialing’s AWS-hosted infrastructure, or any networks
        connected to the Site.
        </p>
        <p className={styles.content}>
             e. Use any robot, spider, scraper, or automated device to access the Site for any purpose without
        our prior written consent.
        </p>
        <p className={styles.content}>
              f. Mirror or frame the Site, or link to any page other than the Site’s homepage, without our
        express permission.
        </p>
       <p className={styles.content}>
            Any unauthorized use terminates the limited permission granted under these Terms.
       </p>
       <h1 className={styles.subheader}>5. Intellectual Property</h1>
       <p className={styles.content}>
            5.1. All content on the Site—including text, graphics, logos, icons, images, audio, video clips,
            data compilations, and software—is the property of iCredentialing or its licensors and is
            protected by U.S. and international copyright, trademark, and other intellectual property laws.
       </p>
       <p className={styles.content}>
            5.2. Except for the limited rights expressly granted herein, no license or other right, whether by
        implication, estoppel, or otherwise, is granted to you.</p>
       <p className={styles.content}>
            5.3. You may not mirror any content from this Site on another website or in any other media
        without iCredentialing’s prior written consent.
       </p>
        <h1 className={styles.subheader}>
            6. Confidential or Proprietary Information
        </h1>
        <p className={styles.content}>
            6.1. iCredentialing does not seek to receive confidential or proprietary information through the
        public Site. Any information or materials you transmit via the Site will be deemed non-
        <strong>confidential</strong> and <strong> non-proprietary</strong>.
        </p>
        <p className={styles.content}>
            6.2.<strong> Do not submit any Protected Health Information (PHI) or professional credentialing
        documentation via the public Site.</strong> All such data must be entered or uploaded only after you
        receive secure login credentials to our HIPAA-compliant portal in connection with a formal
        service relationship.
        </p>
        <p className={styles.content}>
            6.3. Personally identifiable information provided to obtain Services (e.g., name, email, phone)
        will be handled in accordance with our Privacy Policy. Please review our Privacy Policy for
        details on how we manage and protect personal data.
        </p>
        <h1 className={styles.subheader}>
            7. Third-Party Links
        </h1>
       <p className={styles.content}>
            7.1. For your convenience, the Site may contain links to websites operated by third parties (e.g.,
        licensure boards, accrediting bodies, partner organizations). iCredentialing does not endorse,
        control, or assume responsibility for the content, privacy practices, or terms of use of third-party
        sites.
       </p>
       <p className={styles.content}>
            7.2. Accessing third-party sites is at your own risk. Please review any such site’s privacy policy
        and terms of use before providing any personal or professional information.
       </p>
       <h1 className={styles.subheader}>8. Disclaimer of Warranties</h1>
      <p className={styles.content}>
            8.1. <strong className={styles.uppercasetext}>YOUR USE OF THE SITE IS AT YOUR OWN RISK.</strong>  The Site and all information it
        contains are provided <strong className={styles.uppercasetext}>“AS IS,” “AS AVAILABLE,” and “WITH ALL FAULTS.” </strong> To the
        fullest extent permitted by law, iCredentialing disclaims all warranties—express, implied,
        statutory, or otherwise—including, without limitation, warranties of merchantability, fitness for a
        particular purpose, accuracy, timeliness, title, non-infringement, or uninterrupted, secure, or
        error-free operation.
      </p>
      <p className={styles.content}>
            8.2. iCredentialing makes no representation or warranty that any content on the Site ensures
        compliance with <strong className={styles.uppercasetext}>CMS, NCQA, URAC, TJC,</strong><strong> or any other healthcare accreditation,
        credentialing, or licensure standards.</strong> Only duly executed credentialing contracts, Business
        Associate Agreements, and service-level agreements guarantee compliance with those
        requirements.
      </p>
      <p className={styles.content}>
            8.3. iCredentialing provides no assurance that any reported problems on the Site will be resolved
        or that our website will operate without interruption, errors, or security breaches.
      </p>
      <h1 className={styles.subheader}>9. Limitation of Liability</h1>
      <p className={styles.content}>
            9.1. To the fullest extent permitted by law, iCredentialing will not be liable for any direct,
        indirect, punitive, incidental, special, consequential, or exemplary damages (including, without
        limitation, damages for loss of profits, data, goodwill, or other intangible losses) arising out of or
        relating to the Site or these Terms, even if iCredentialing has been advised of the possibility of
        such damages.
      </p>
      <p className={styles.content}>
            9.2. Without limiting the foregoing, iCredentialing’s total aggregate liability for any claim
        arising out of or relating to these Terms or the Site will not exceed the greater of (a) one hundred
        U.S. dollars (US $100) or (b) the amount you paid to access or use the Site during the six (6)
        months preceding the event giving rise to liability.
      </p>
      <h1 className={styles.subheader}>10. Indemnification</h1>
      <p className={styles.content}>
            10.1. You agree to indemnify, defend, and hold harmless iCredentialing, its affiliates, officers,
        directors, employees, agents, and representatives from and against any and all claims, liabilities,
        damages, judgments, awards, losses, costs, expenses, or fees (including reasonable attorneys’
        fees) arising out of or relating to (a) your violation of these Terms; (b) your use of the Site; (c)
        any unauthorized submission of PHI or proprietary information via the Site; or (d) any violation
        of applicable federal or state healthcare laws and regulations (e.g., HIPAA, HITECH, NCQA,
        URAC, CMS, TJC).
      </p>
      <h1 className={styles.subheader}>11. Governing Law; Venue</h1>
      <p className={styles.content}>
            11.1. These Terms and any dispute arising out of or related to the Site or these Terms are
        governed by and construed in accordance with the laws of the State of California, without regard
        to its conflict-of-law rules.
      </p>
      <p className={styles.content}>
           11.2. You agree to submit to the exclusive jurisdiction and venue of the state or federal courts
        located in Orange County, California, for any litigation arising out of or related to these Terms or
        the Site. 
      </p>
      <p className={styles.content}>
            11.3. Note: This choice of California law applies only to disputes concerning the public Site and
        these Terms. Any dispute specifically relating to credentialing, payer-enrollment, or other
        professional services (including PHI handling) will be governed by the law and venue specified
        in your separate Service Agreement or Master Services Agreement with iCredentialing.
      </p>
      <h1 className={styles.subheader}>12. Severability</h1>
      <p className={styles.content}>
            If any provision of these Terms is held to be unlawful, void, or unenforceable, that provision will
        be deemed severable and will not affect the validity or enforceability of the remaining
        provisions, which will remain in full force and effect.
      </p>
      <h1 className={styles.subheader}>13. Entire Agreement; No Waiver</h1>
      <p className={styles.content}>
            13.1. These Terms constitute the entire agreement between you and iCredentialing regarding
        your use of the Site and supersede any prior or contemporaneous communications.
      </p>
      <p className={styles.content}>
            13.2. <strong>These Terms apply solely to the public Site.</strong> Any credentialing, payer-enrollment, or
        related services are governed exclusively by a separate Service Agreement or Master Services
        Agreement.
      </p>
      <p className={styles.content}>
            13.3. No waiver of any provision of these Terms will be effective unless in writing and signed by
        an authorized representative of iCredentialing. The failure of iCredentialing to enforce any right
        or provision of these Terms will not constitute a waiver of that right or provision.
      </p>
      <h1 className={styles.subheader}>14. Contact Us</h1>
      <p className={styles.content}>
            If you have questions, concerns, or requests regarding these Terms or the Site, please contact:
      </p>
       <p>
            <strong>Attn: Legal Office / Privacy Officer</strong>
       </p>
        <p>
            2372 Morse Ave, #1020
        </p>
        <p>
            Irvine, CA 92614 USA
        </p>
        <p>
            Phone: (949) 390-2661
        </p>
        <p>
            Email: <strong>legal@icredentialing.com</strong>
        </p>    
        <p className={styles.lastcontent}> 
            If you suspect any violation of HIPAA, HITECH, or other applicable healthcare laws, you may
            report it to our Privacy Officer at <strong>privacy@icredentialing.com</strong> or call (714) 559-5493.
        </p>    
    </div> 
  )
}

export default Termsofuse